
import UserDataManager from "../../../../../../manager/user_manager";
import { JdTableModel } from "./jd_table_model";
import { JdTableView } from "./jd_table_view";
import { JdSeatEntity } from "../seat/jd_seat_entity";
import { JdPokerComponent } from "../../component/jd_poker_component";
import { JdConst } from "../../data/jd_define";
import GameServer from "../../../../../hall/server/gameserver/game_server";
import { JdHelp } from "../../help/jd_help";
import ModelData, { IUserData } from "../../../../../public/model_data";
import { JdTableData } from "../../data/jd_table_data";
import { JdSeatConfig, JdSeatState } from "../../component/jd_seat_state_component";
import { Jd } from "../../../../net/proto/proto_jd_game";
import { NetMsgJd } from "../../../../net/net_msg_data_map_jd";
import { JdRoom } from "../../../../net/proto/proto_jd_room";
import EventManager from "../../../../../../manager/event_manager";
import MVVMBase from "../../../../../../framework/core/mvvm/mvvm_base";
import { PokerCommonColor } from "../../../../../k9/module/table/component/poker_com_color";
import TableBaseView from "../../../../../table/module/table_base/table_base_view";
//基础数据交互层
export abstract class JdTableEntityBase extends cc.EventTarget {

    protected modeBase:JdTableModel;
    
    protected viewBase:JdTableView;
    //座位实体(下标即viewID)
    protected seatEntityBase:JdSeatEntity[];

    protected seatNode:cc.Node[];

    protected mvvBase:MVVMBase = null;

    tableView:TableBaseView = null;

    //牌局数据
    get boardData(){
        return this.modeBase.boardData;
    }

    get settingData():JdTableData.Setting{
        return this.modeBase.settingData;
    }

    get commonData(){
        return this.modeBase.commonData;
    }

    //获取所有viewID的配置
    get seatInfo():JdSeatState[]
    {
        return this.viewBase.seatInfo;
    }

    get seatInfoPrefab():cc.Node{
        return this.viewBase.seatPlayerPrefab;
    }

    //玩家扑克
    get playerHands():PokerCommonColor[]{
        return this.viewBase.twoHands;
    }

    get dealerNode():cc.Node{
        return this.viewBase.dealerNode;
    }

    get chatNode():cc.Node{
        return this.viewBase.chatNode;
    }

    //自己的座位 0是站起
    private _selfServerSeatID:number = 0;

    //维持座位不变的id
    private _baseSeatID:number = 6;

    get selfServerSeatID(){
        return this._selfServerSeatID;
    }

    set selfServerSeatID(v:number){
        this._selfServerSeatID = v;
        if (v == 0) {
            this.emit(JdConst.refreshUI,null);
        }else{
            this._baseSeatID = v;
        }
    }

    get seatData():JdTableData.SeatPlayerData[]{
        return this.modeBase.seatData;
    }

    getSeatData(playerid:number):JdTableData.SeatPlayerData{
        return this.findSeatInfo(playerid);
    }

    //牌桌座位数量
    protected tableSeatNumb:number = 0;

    create(){
        this.baseModelInstance();
        this.seatEntityBase = [];
        this.onCreate();
    }

    //model创建完成
    onCreate(){};

    initNetMessage(base:MVVMBase,baseView:TableBaseView){
        this.modeBase.init(GameServer.instance.netClient);
        this.modeBase.clearMsgEvent();
        this.mvvBase = base;
        this.tableView = baseView
        this.registerNetMessage();
    }

    createTableView(parent:cc.Node,tablePrefab:cc.Node){
        this.baseViewInstance(parent,tablePrefab);
        //创建玩家实体
        this.onViewInited();
    }

    //ui 创建完成
    onViewInited(){
        this.reset();
        //this.test()
    };

    baseModelInstance(){
        if (!this.modeBase) {
            this.modeBase = new JdTableModel();
            this.modeBase.Init();
        }
    }

    baseViewInstance(parent:cc.Node,tablePrefab:cc.Node){
        let node = JdHelp.AddChild(tablePrefab,parent);
        if (!node) {
            cc.warn('创建牌桌失败prefab is null！');
            return;
        }
        if (!parent) {
            return;
        }
        if (!this.viewBase){
            this.viewBase = new JdTableView();
        }
        this.viewBase.Init(node);
    }

    //移动手牌
    movePokers(idx:number,toNode:cc.Node,comp?:Function){
        this.viewBase.pokersMove(idx,toNode,comp);
    }

    //获取座位实体
    getSeatEntity(viewID:number,func:Function){
        let seatEntity = this.seatEntityBase[viewID];
        if (seatEntity) {
            func(seatEntity);
        }
    }

    getEntityServerID(serverSeatID:number):JdSeatEntity{
        let seatEntity = this.seatEntityBase[this.getViewID(serverSeatID)];
        if (seatEntity) {
            return seatEntity;
        }
        return null;
    }

    getEntityByPlayerID(playerID):JdSeatEntity{
        for (let entity of this.seatEntityBase) {
            if (entity.playerID == playerID) {
                return entity;
            }
        }
        return null;
    }

    //根据服务器seatID获取viewID
    // server 1-9
    getViewID(serverSeatID:number):number{
        for (let i = 0; i < this.seatEntityBase.length; i++) {
            let entityBase = this.seatEntityBase[i];
            if (entityBase.serverSeatID == serverSeatID) {
                return i;
            }
        }
        return -1;
    }

    //根据viewID 获取serverID
    getSeatID(viewID:number):number{
        let seatEntity = this.seatEntityBase[viewID];
        if (seatEntity) {
            return seatEntity.serverSeatID;
        }
        return -1;
    }

    findSeatInfo(playerID:number):JdTableData.SeatPlayerData{
        return this.modeBase.findSeatInfo(playerID);
    }

    findSeatInfoBySeatID(seatID:number):JdTableData.SeatPlayerData{
        return this.modeBase.findSeatInfoBySeatID(seatID);
    }

    isRole(playerID:number){
        return playerID == ModelData.instance.roleData.id;
    }

    getPlayerSeatData():JdTableData.SeatPlayerData{
        return this.findSeatInfoBySeatID(this.selfServerSeatID);
    }

    //我是否正在游戏中
    isSelfPlaying(){
        if (this.selfServerSeatID == 0) {
            return false;
        }else{
            let id = ModelData.instance.roleData.id;
            return this.isPlayerInGame(Number(id));
        }
    }

    isPlayerInGame(playerID:number){
        let data = this.findSeatInfo(playerID)
        if (data) {
             if(data.state != 0
                && data.state != 8){
                return true;
             }
        }
        return false;
    }

    //设置自动出牌
    setAutoSetting(auto:JdTableData.AutoSetting){
        if ( this.settingData.autoCheck == JdTableData.AutoSetting.None) {
            this.settingData.autoCheck = auto;
        }else{
            if (this.settingData.autoCheck != auto) {
                this.settingData.autoCheck = auto;
            }else{
                this.settingData.autoCheck = JdTableData.AutoSetting.None;
            }
        }
    }

    //自己坐下的时候移动位置
    selfSeatDown(seatID:number){
        let viewID = this.getViewID(seatID);
        this.moveSeatAction(viewID);
    }

    selfSeatDownViewID(viewID:number){
        this.moveSeatAction(viewID);
    }

    private moveSeatAction(shift:number){
        if (shift == 0) {
            return;
        }

        for (let i = 0; i < this.tableSeatNumb; i++) {
            let pos = i;
            let next = (i+ this.tableSeatNumb -1) % this.tableSeatNumb;
            for (let j = 0; j < shift; j++) {
                pos = next;
                next = (next + this.tableSeatNumb -1) % this.tableSeatNumb;
            }

            let vc2 = this.seatInfo[pos].getPosition();
            
            //更新布局
            this.updateSeatToEndLayOut(i,pos);

            this.seatEntityBase[i].moveTo(vc2,0.3,()=>{
            });

            this.seatEntityBase[i].sortID = pos;
        }
        //排序
        this.seatEntityBase.sort(function(a:JdSeatEntity,b:JdSeatEntity){
            return a.sortID-b.sortID;
        })
    }

    protected playerSitDownSeatID(seatID:number){
        let viewID = this.getViewID(seatID);
        if (viewID != -1) {
            this.playerSitDown(viewID);
        }
    }

    //玩家坐下
    playerSitDown(viewID:number){
        this.updateSeatToEndLayOut(viewID,viewID);
        this.getSeatEntity(viewID,(e:JdSeatEntity)=>{
            e.playerSitDown();
        });
    }

    protected playerStandUpSeatID(seatID:number){
        let viewID = this.getViewID(seatID);
        if (viewID != -1) {
            this.playerStandUp(viewID);
        }
    }

    playerStandUp(viewID:number){
        this.updateSeatToEndLayOut(viewID,viewID);
        this.getSeatEntity(viewID,(e:JdSeatEntity)=>{
            e.playerStandUp();
        });
    }

    //更新座位位置
    protected updateSeatPos(viewID:number){
        let seatEntity = this.seatEntityBase[viewID];
        let pos = this.seatInfo[viewID].getPosition();
        seatEntity.stopAllActions();
        seatEntity.setPosition(pos);
        //更新布局
        this.updateSeatToEndLayOut(viewID,viewID);
    }

    //更新布局
    protected updateSeatToEndLayOut(curViewID:number,endViewID:number){
        let seatInfo = this.seatInfo[endViewID];
        let seatEntity = this.seatEntityBase[curViewID];
        if (seatInfo) {
            seatInfo.refreshNodeInfo((seatConfig:JdSeatConfig)=>{
                seatEntity.updateSeatInfo(seatConfig);
            })
        }
    }

    //玩家操作
    ReqPlayerOperator(ds:JdConst.Operator,mount:number = 0){
        let setting = this.settingData;
        if (setting.isMyRound) {//我方回合
            //是否可以让牌
            if (ds == JdConst.Operator.All_in) {//点击AllIn
                this.modeBase.send_BetRsp(setting.chips,true)
            }else if (ds == JdConst.Operator.Raise) {//加注
                this.modeBase.send_BetRsp(mount);
            }else if (ds == JdConst.Operator.GiveUp) {//弃牌
                this.modeBase.send_foldRsp();
            }else{
                let isCanCheck = setting.params == 0;
                if (isCanCheck) {
                    this.modeBase.send_BetRsp(0);
                }else{
                    let isCanCall = setting.params < setting.chips;
                    if (isCanCall) {//跟
                        this.modeBase.send_BetRsp(setting.params);
                    }
                }
            }
            //获取我方数据
            this.emit(JdConst.refreshUI,null);
        }
    }

    //直接处理action 然后服务器返回进行验证
    operatorAction(ds:JdConst.Operator,mount?:number){
        let setting = this.settingData;
        if (setting.isMyRound) {//是否是我方回合
            //直接操作金额
            this.emit(JdConst.refreshUI,null);
        }
    }

    //注册网络监听
    private registerNetMessage(){
        let self = this;

        self.modeBase.subscibeMsgEvent<Jd.IGameInfo>(NetMsgJd.GameInfo,function(protoData){
            self.enterGame(protoData);
        },true);

        self.modeBase.subscibeMsgEvent<Jd.IBankerNotify>(NetMsgJd.BankerNotify,function(data){
            self.bankerNotify(data);
        },true)

        self.modeBase.subscibeMsgEvent<Jd.IBetPoolNotify>(NetMsgJd.BetPoolNotify,function(data){
            self.betPoolNotify(data);
        },true)

        self.modeBase.subscibeMsgEvent<Jd.IDealCardNotify>(NetMsgJd.DealCardNotify,function(data){
            self.dealCardNotify(data);
        },true)

        self.modeBase.subscibeMsgEvent<Jd.IGameSettle>(NetMsgJd.GameSettle,function(data){
            self.gameSettle(data);
        },true)

        self.modeBase.subscibeMsgEvent<Jd.ITimeoutNotify>(NetMsgJd.TimeoutNotify,function(data){
            self.timeoutNotify(data);
        },true)

        self.modeBase.subscibeMsgEvent<Jd.IFoldNotify>(NetMsgJd.FoldNotify,function(data){
            self.foldNotify(data);
        },true)

        self.modeBase.subscibeMsgEvent<Jd.IFoldRsp>(NetMsgJd.FoldRsp,function(data){
            self.foldRsp(data);
        },true)

        self.modeBase.subscibeMsgEvent<Jd.IBetNotify>(NetMsgJd.BetReq,function(data){
            self.betNotify(data);
        },true)

        self.modeBase.subscibeMsgEvent<JdRoom.IEnterBroadcast>(NetMsgJd.EnterBroadcast, function (protoData) {
            self.onNetMsgEnterNotify(protoData)
        },true)

        //离开广播
        self.modeBase.subscibeMsgEvent<JdRoom.ILeaveBroadcast>(NetMsgJd.LeaveRoomNotify, function (protoData) {
            self.leaveBroadcast(protoData)
        },true)

        self.modeBase.subscibeMsgEvent<JdRoom.ILeaveRsp>(NetMsgJd.LeaveRoom, function (protoData) {
            self.leaveRoomRsp(protoData)
        },true)

        self.modeBase.subscibeMsgEvent<Jd.IBetRsp>(NetMsgJd.BetRsp, function (protoData) {
            self.betRsp(protoData)
        },true)

        self.modeBase.subscibeMsgEvent<Jd.ICarryCoinRsp>(NetMsgJd.CarryCoin, function (protoData) {
            self.carryCoin(protoData)
        },true)

        self.modeBase.subscibeMsgEvent<JdRoom.IStartBroadcast>(NetMsgJd.StartBroadcast, function (protoData) {
            self.startBroadcast(protoData)
        },true)

        self.modeBase.subscibeMsgEvent<Jd.ICarryWantsNotify>(NetMsgJd.CarryWantsNotify, function (protoData) {
            self.carryWantsNotify(protoData)
        },true)


        self.modeBase.subscibeMsgEvent<Jd.ICarryCoinNotify>(NetMsgJd.CarryCoinNotify, function (protoData) {
            self.carryCoinNotify(protoData)
        },true)

        self.modeBase.subscibeMsgEvent<Jd.IAccountBalanceNotify>(NetMsgJd.AccountBalanceNotify, function (protoData) {
            self.accountBalanceNotify(protoData)
        },true)
        
    }


    enterGame(protoData:Jd.IGameInfo){
        this.modeBase.boardData = this.modeBase.boardData || new JdTableData.BoardData();
        this.modeBase.boardData.banker = protoData.bankerSeatId;
        this.modeBase.boardData.pot = protoData.pot;
        //公共数据
        this.modeBase.commonData = this.modeBase.commonData || new JdTableData.commonData();
        this.modeBase.commonData.maxBet = 0;//本轮最大下注
        let roomConf = JSON.parse(protoData.roomConf);
        this.modeBase.commonData.min_join_coin = roomConf.game_BetTakeMin;
        this.modeBase.commonData.max_join_coin = roomConf.game_BetTakeMax;
        this.modeBase.commonData.game_BetMin = roomConf.game_BetMin;//最小下注
        this.modeBase.commonData.minJoinPeople = roomConf.pub_MinPlayerNum;
        this.modeBase.commonData.sidePotIndex = 0;
        this.modeBase.commonData.isNeedWaite = true;
        this.modeBase.commonData.ackId = 0;
        this.modeBase.commonData.event = 0;
        this.modeBase.commonData.progress = 1;
        this.onRevGameInfo(protoData);
    };

    accountBalanceNotify(proto:Jd.IAccountBalanceNotify){
        let seatData = this.findSeatInfoBySeatID(proto.seatId);
        if (seatData) {
            if (proto.coin != undefined) {
                seatData.account_balance = proto.coin;
            }
        }
    }

    carryCoinNotify(proto:Jd.ICarryCoinNotify){
    
    }

    updateAddBet(isPlay:boolean){
        this.viewBase.updateBetAnim(isPlay);
    }


    carryWantsNotify(proto:Jd.ICarryWantsNotify){
        
    }

    startBroadcast(protoData:JdRoom.IStartBroadcast){
        //更新版局编号
        this.emit(JdConst.updateUI,protoData.roundId);
    }

    bankerNotify(protoData:Jd.IBankerNotify){
        this.modeBase.boardData.banker = protoData.seatId;
    }

    betRsp(proto:Jd.IBetRsp){
        cc.log('------------------>>>',proto);
    }

    carryCoin(proto:Jd.ICarryCoinRsp){
        cc.log('--->>>carrycoin',proto.errNo);
    }

    leaveRoomRsp(proto:JdRoom.ILeaveRsp){

    }

    //归池通知
    betPoolNotify(proto:Jd.IBetPoolNotify){
        this.commonData.maxBet = 0;
        //重置座位信息
        
        for (let seat of this.seatData) {
            seat.bet = 0;
        }
    }

    //发牌通知
    dealCardNotify(proto:Jd.IDealCardNotify){
        //同步玩家数据
        for (let seat of proto.seatList) {
            let seatInfo = this.findSeatInfoBySeatID(seat.seatId);
            if (seatInfo) {
                seatInfo.cards = seat.cards.concat([]);
                if (seatInfo.cards.length == 2) {
                    JdHelp.sortCards(seatInfo.cards);
                }
                seatInfo.state = seat.state;//状态
                seatInfo.card_point = seat.cardPoint;
                seatInfo.card_type = seat.cardType;
                seatInfo.account_balance = seat.accountBalance;
            }
        }

    }

    //结算通知
    gameSettle(proto:Jd.IGameSettle){

        for (let seat of proto.seatList) {
            let seatInfo = this.findSeatInfoBySeatID(seat.seatId);
            if (seatInfo) {
                seatInfo.coin_balance = seat.coinBalance;
                seatInfo.card_type = seat.cardType;
                seatInfo.card_point = seat.cardPoint;
                seatInfo.state = seat.state;
                seatInfo.account_balance = seat.accountBalance;
            }
        }

        if (proto.seatList.length > 0) {
            this.initPlayers(proto.seatList);
        }
        this.boardData.gameState = JdConst.GameState.GameSettle

        //更新账户余额
        let data = this.findSeatInfoBySeatID(this.selfServerSeatID);
        if (data) {
            UserDataManager.balanceChangeMessage(data.account_balance)
        }
    }

    gameState(){
        if (this.boardData) {
            return this.boardData.gameState;
        }
        return 0
    }

    //定时器通知
    timeoutNotify(proto:Jd.ITimeoutNotify){
        if (proto.event == 888) {
            if (this.commonData.event != undefined) {
                this.commonData.event = 888;
                this.commonData.ackId = parseInt(proto.param.toString()) ; 
            }
        }
    }

    //弃牌广播
    foldNotify(proto:Jd.IFoldNotify){
        let data = this.findSeatInfoBySeatID(proto.seatId);
        if (data) {
            data.state = JdConst.SeatState.fold;
        }
    }

    //弃牌错误码
    foldRsp(proto:Jd.IFoldReq){

    }

    betNotify(proto:Jd.IBetNotify){
        let data = this.findSeatInfoBySeatID(proto.seatId);
        if (data) {
            data.bet += proto.betCoin;
            if (this.commonData.maxBet <= data.bet) {
                this.commonData.maxBet = data.bet;
            }
            data.coin_balance = proto.coinBalance;
            data.state = proto.state;
            data.account_balance = proto.accountBalance;

            UserDataManager.setUserGameTableCurrency(data.player_id,data.account_balance)
        }
        if (proto.pot > 0) {
            this.boardData.pot = proto.pot;
        }
    }

    leaveBroadcast(protoData:JdRoom.ILeaveBroadcast){
        if (!this.isRole(protoData.playerId)) {
            this.modeBase.removeSeatInfo(protoData.playerId);
        }
        if (protoData.reason) {
            if (protoData.reason != 0) {
                if (this.isRole(protoData.playerId)) {
                    //ModuleManager.instance.toastKey("jd_leave" + protoData.reason)
                }
            }
        }
        cc.log('--------->>>>>离开牌桌原因',protoData.reason)
    }

    onNetMsgEnterNotify(protoData:JdRoom.IEnterBroadcast){
        let posInfo = protoData.posInfo;
        let seatData = new JdTableData.SeatPlayerData();
        seatData.player_id = posInfo.playerId;
        seatData.seat_id = posInfo.posIndex;
        seatData.name = this.setPlayerData(protoData.userJson,posInfo.playerId);
        seatData.coin_balance = posInfo.coinBalance;//携带的金币数量
        seatData.state = 0;
        seatData.bet = 0;
        this.modeBase.pushSeatInfo(seatData);
        let entity = this.getEntityServerID(posInfo.posIndex)
        if (entity) {
            entity.reset();
            entity.seatData = seatData;
            
        }
        this.playerSitDownSeatID(seatData.seat_id);
        this.playerEnterRoom();
        if (entity) {
            entity.onUserActive();
        }
        UserDataManager.setUserGameTableCurrency(posInfo.playerId,posInfo.coinBalance)

    }

    setPlayerData(str:string,playid:number):string{
        UserDataManager.setUserJsonData(str);
        let userdata : IUserData = UserDataManager._userDatas[playid.toString()]
        if (userdata) {
            return userdata.name;
        }
        return '';
    }

    //离开游戏
    leaveGame(){
    }

    onRevGameInfo(protoData:Jd.IGameInfo){
        //重置牌桌
        this.reset();

        this.tableSeatNumb = protoData.maxPlayerCnt;

        this.boardData.gameState = JdConst.GameState.Init

        this.initGame(protoData);
        
        this.initPlayers(protoData.seatList);

        //操作设置数据
        if (!this.modeBase.settingData) {
            this.modeBase.settingData = new JdTableData.Setting();
        }
        this.modeBase.settingData.reset();
        this.modeBase.settingData.min = this.commonData.game_BetMin;

        EventManager.instance.dispatch('Game_Table_Start')
    }

    //重置牌桌信息
    initPlayers(players:Jd.ISeatInfo[]){
        if (this.seatEntityBase) {
            for (let seatEntity of this.seatEntityBase) {
               seatEntity.playingReset();
            } 
        }
        this.selfServerSeatID = 0;
        this.modeBase.seatData = [];
        this.modeBase.seatData.length = 0;
        for (let player of players) {
            let data = new JdTableData.SeatPlayerData();
            data.player_id = player.playerId;
            data.seat_id = player.seatId;
            data.coin_balance = player.coinBalance;
            data.bet = player.currBet;//下注额
            data.name = this.setPlayerData(player.userJson,player.playerId);
            data.cards = player.cards;
            JdHelp.sortCards(data.cards);
            data.state = player.state || 0;
            data.card_type = player.cardType;
            data.card_point = player.cardPoint;
            data.account_balance = player.accountBalance;
            this.modeBase.pushSeatInfo(data);
            if (this.isRole(data.player_id)) {
                this.selfServerSeatID = data.seat_id;
            }
            UserDataManager.setUserGameTableCurrency(data.player_id,data.account_balance)
        }

        if (this.selfServerSeatID == 0) {
            this.seatEntityBase[0].serverSeatID = this._baseSeatID || 3;//默认座六号位置
        }else{
            this.seatEntityBase[0].serverSeatID = this.selfServerSeatID;
        }

        this.updateSeatPos(0)

        //其他座位基础设置
        for (let i = 1; i < this.tableSeatNumb; i++) {
            let seatEntity = this.seatEntityBase[i];
            seatEntity.serverSeatID = this.seatEntityBase[i-1].serverSeatID % this.tableSeatNumb + 1;
            this.updateSeatPos(i);
        }
        
        for (let data of this.modeBase.seatData) {
            this.getEntityServerID(data.seat_id).seatData = data;
        }
    }

    //游戏初始化执行
    protected initGame(protoData:Jd.IGameInfo){
       
    }

    playerEnterRoom(){

    }

    //是否有玩家在游戏中
    isHavePlayerInGame():boolean{
        if (this.modeBase.seatData) {
            for (let i = 0; i < this.modeBase.seatData.length; i++) {
                let data = this.modeBase.seatData[i];
                if (data && data.state != 0
                    && data.state != 8) {
                    return true;
                }
            }
        }
        return false;
    }

    //更新下注
    protected resetMount(){
        this.commonData.maxBet = 0;
    }

    showHandCards(cards:number[]){
        this.viewBase.showHandCards(cards);
    }

    showTwoHandsOnly(cards:number[]){
        this.viewBase.showShowPokerOnly(cards);
    }

    showCardsType(){
        let seatData = this.getPlayerSeatData();
        if (seatData) {
            if (seatData.card_type) {
                this.viewBase.showCardsType(seatData.card_type,seatData.card_point);
            }else{
                if (seatData.cards.length == 2) {//2张
                    this.viewBase.showCardsType(1,seatData.card_point);
                }
            }
        }
    }

    setHandState(isShow:boolean){
        this.viewBase.setHandState(isShow);
    }

    maskHands(){
        this.viewBase.maskMyCards();
        this.viewBase.setPatternMask(true);
    }

    resumeHands(cards:number[]){
        //直接显示手牌
        this.viewBase.resumeHands(cards);
    }

    resetHands(){
        this.viewBase.resetHands();
    }

    //游戏中的entity 是否排序 第一个是我放，然后依次执行
    inGameSeatEntity(isSort?:boolean):JdSeatEntity[]{
        let seatEntity:JdSeatEntity[] = [];
        for (let se of this.seatEntityBase) {
            if (se.isPlayingGame()) {
                seatEntity.push(se);
            }
        }
        //根据serverID排序
        seatEntity.sort(function(a:JdSeatEntity,b:JdSeatEntity){
            return a.serverSeatID-b.serverSeatID;
        })

        //起始为庄家
        if (isSort) {
            let sortEntity = [];
            let otherEntity = [];
            let insert = false;
            for (let seat of seatEntity) {
                if (seat.seatData) {
                    let isBank = seat.seatData.seat_id == this.boardData.banker//找到庄家
                    if (isBank) {
                        sortEntity.push(seat);
                        insert = true;
                    }else{
                        if (insert) {
                            sortEntity.push(seat);
                        }else{
                            otherEntity.push(seat);
                        }
                    }
                }
            }
            seatEntity.length = 0;
            seatEntity = sortEntity.concat(otherEntity);
        }
        return seatEntity;
    }

    req_leaveRoom(){
        this.modeBase.send_Leave();
    }

    canLeave():boolean{
        let data = this.getPlayerSeatData();
        let isCanLeave = !data || data.state == 0 || data.state == 8;
        return isCanLeave;
    }

    showTypeNode(isShow:boolean){
        this.viewBase.myTypeNode.active = isShow;
    }

    sendAck(){
        this.modeBase.send_ack();
    }

    throwCardsAction(){

    }

    
    dealCardsAction(haveCards:number,showCards:number,cards?:number[]){}
    gameOverCountdown(nu:number){};
    ttt(id:number){

        //this.gameOverCountdown(5);
        // for (let entity of this.inGameSeatEntity()) {
        //     entity.checkBetAction(100,()=>{
        //         cc.log('xxxx');
        //         entity.guiChi(this.viewBase.dealerNode);
        //     })

            
        //     // entity.setActiveInfo(true);
        //     //entity.updateTableBet(100,true)
        //     // entity.setOpTime(5,15);

        //     //this.BrightHands(entity.seatData.seat_id,[12,23,45],1)
        // }
        //this.dealCardsAction(0,2);
        this.setHandState(true);
        this.dealCardsAction(0,2,[21,22])
        // let entity = this.getEntityServerID(this.selfServerSeatID);
        // entity.setSmallCard(true);
        // entity.seatData.cards = [0,0]
        // entity.dealCards(this.viewBase.dealerNode,0);
        // entity.dealCards(this.viewBase.dealerNode,1);
    }
    idx = 1;
    gggg(){

        let entity = this.getEntityServerID(this.selfServerSeatID);
        if (entity) {
            entity.showEndHands([21,24,23],1,1);
        }

    }

    //重置牌桌数据
    reset(){
        if (this.commonData) {
            this.commonData.sidePotIndex = 0;
            this.commonData.maxBet = 0;
            this.commonData.event = 0;
            this.commonData.isNeedWaite = true;
        }

       if (this.settingData) {
           this.settingData.reset();
       }
       
       if (this.seatData ) {
           for (let seat of this.seatData) {
               seat.reset();
           }
       }
       if (this.boardData) {
           this.boardData.gameState = JdConst.GameState.Init;
       }
    }

    //退出牌桌
    exitTable(){

    }

    clear(){
        
    }
}
